/*
interface IconProps extends SvgIconProps {}

export function IconMeterReading(props: IconProps) {
  return (
    <SvgIcon
      {...props}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.83342 5.83334H29.1668C29.9403 5.83334 30.6822 6.14063 31.2291 6.68762C31.7761 7.2346 32.0834 7.97646 32.0834 8.75001V26.25C32.0834 27.0236 31.7761 27.7654 31.2291 28.3124C30.6822 28.8594 29.9403 29.1667 29.1668 29.1667H5.83342C5.05987 29.1667 4.318 28.8594 3.77102 28.3124C3.22404 27.7654 2.91675 27.0236 2.91675 26.25V8.75001C2.91675 7.97646 3.22404 7.2346 3.77102 6.68762C4.318 6.14063 5.05987 5.83334 5.83342 5.83334V5.83334ZM5.83342 8.75001V26.25H16.0417V8.75001H5.83342ZM29.1668 26.25V8.75001H27.3584C27.7084 9.53751 27.6355 10.3104 27.6355 10.3979C27.5334 11.375 26.848 12.3958 26.6001 12.7604L23.2022 16.4792L28.0438 16.45L28.0584 18.2292L20.4751 18.1854L20.4167 16.7271C20.4167 16.7271 24.8647 12.0167 25.0834 11.5938C25.2876 11.1854 26.1188 8.75001 24.0626 8.75001C22.2688 8.82293 22.473 10.6458 22.473 10.6458L20.2272 10.6604C20.2272 10.6604 20.2417 9.69793 20.7813 8.75001H18.9584V26.25H22.7209L22.7063 24.9958L24.1209 24.9813C24.1209 24.9813 25.448 24.7479 25.4626 23.45C25.5209 21.9917 24.2813 21.9917 24.0626 21.9917C23.873 21.9917 22.5022 22.0646 22.5022 23.2604H20.2855C20.2855 23.2604 20.3438 20.2563 24.0626 20.2563C27.8543 20.2563 27.6501 23.2021 27.6501 23.2021C27.6501 23.2021 27.7084 25.025 26.0313 25.7104L26.7897 26.25H29.1668ZM13.0084 23.3333H10.8209V14.875L8.19592 15.6917V13.8979L12.7751 12.2646H13.0084V23.3333Z" />
    </SvgIcon>
  )
}

export function IconGas(props: IconProps) {
  return (
    <SvgIcon
      {...props}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.4083 18.0104C26.1187 12.0604 17.9666 11.7396 19.9353 3.09165C20.0812 2.44998 19.3958 1.95415 18.8416 2.28956C13.5478 5.4104 9.74158 11.6666 12.9353 19.8625C13.1978 20.5333 12.4103 21.1604 11.8416 20.7229C9.202 18.725 8.92492 15.8521 9.15825 13.7958C9.24575 13.0375 8.25408 12.6729 7.83117 13.3C6.8395 14.8166 5.83325 17.2666 5.83325 20.9562C6.38742 29.1229 13.2853 31.6312 15.7645 31.9521C19.3083 32.4041 23.1437 31.7479 25.8999 29.225C28.9333 26.4104 30.0416 21.9187 28.4083 18.0104ZM14.8749 25.3458C16.9749 24.8354 18.0541 23.3187 18.3458 21.9771C18.827 19.8916 16.9458 17.85 18.2145 14.5541C18.6958 17.2812 22.9833 18.9875 22.9833 21.9625C23.0999 25.6521 19.1041 28.8166 14.8749 25.3458Z"
        fill="#9AD200"
      />
    </SvgIcon>
  )
}

export function IconElectricity(props: IconProps) {
  return (
    <SvgIcon
      {...props}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 2.94583C9.46455 2.94583 2.9458 9.46458 2.9458 17.5C2.9458 25.5354 9.46455 32.0542 17.5 32.0542C25.5354 32.0542 32.0541 25.5354 32.0541 17.5C32.0541 9.46458 25.5354 2.94583 17.5 2.94583ZM16.7416 29.1667V20.0375H11.6666L18.9583 5.83333V14.9625H23.8437L16.7416 29.1667Z"
        fill="#9AD200"
      />
    </SvgIcon>
  )
}

export function IconPayment(props: IconProps) {
  return (
    <SvgIcon
      {...props}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.625 17.5V8.74999C30.625 7.14582 29.3125 5.83332 27.7083 5.83332H26.25V2.91666H23.3333V5.83332H11.6667V2.91666H8.75V5.83332H7.29167C5.6875 5.83332 4.375 7.14582 4.375 8.74999V29.1667C4.375 30.7708 5.6875 32.0833 7.29167 32.0833H17.5V29.1667H7.29167V14.5833H27.7083V17.5H30.625ZM22.8083 29.1667C23.4354 31.2812 25.3896 32.8125 27.7083 32.8125C30.5229 32.8125 32.8125 30.5229 32.8125 27.7083C32.8125 24.8937 30.5229 22.6042 27.7083 22.6042C26.3229 22.6042 25.0542 23.1583 24.1354 24.0625H26.25V26.25H20.4167V20.4167H22.6042V22.5021C23.9167 21.2187 25.725 20.4167 27.7083 20.4167C31.7333 20.4167 35 23.6833 35 27.7083C35 31.7333 31.7333 35 27.7083 35C24.1792 35 21.2333 32.4917 20.5625 29.1667H22.8083Z"
        fill="#9AD200"
      />
    </SvgIcon>
  )
}

export function IconArrowForward(props: IconProps) {
  return (
    <SvgIcon
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 3L7.9425 4.0575L12.1275 8.25H3V9.75H12.1275L7.9425 13.9425L9 15L15 9L9 3Z"
        fill="white"
      />
    </SvgIcon>
  )
}

*/

export const IconMeterReading = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83342 5.83334H29.1668C29.9403 5.83334 30.6822 6.14063 31.2291 6.68762C31.7761 7.2346 32.0834 7.97646 32.0834 8.75001V26.25C32.0834 27.0236 31.7761 27.7654 31.2291 28.3124C30.6822 28.8594 29.9403 29.1667 29.1668 29.1667H5.83342C5.05987 29.1667 4.318 28.8594 3.77102 28.3124C3.22404 27.7654 2.91675 27.0236 2.91675 26.25V8.75001C2.91675 7.97646 3.22404 7.2346 3.77102 6.68762C4.318 6.14063 5.05987 5.83334 5.83342 5.83334V5.83334ZM5.83342 8.75001V26.25H16.0417V8.75001H5.83342ZM29.1668 26.25V8.75001H27.3584C27.7084 9.53751 27.6355 10.3104 27.6355 10.3979C27.5334 11.375 26.848 12.3958 26.6001 12.7604L23.2022 16.4792L28.0438 16.45L28.0584 18.2292L20.4751 18.1854L20.4167 16.7271C20.4167 16.7271 24.8647 12.0167 25.0834 11.5938C25.2876 11.1854 26.1188 8.75001 24.0626 8.75001C22.2688 8.82293 22.473 10.6458 22.473 10.6458L20.2272 10.6604C20.2272 10.6604 20.2417 9.69793 20.7813 8.75001H18.9584V26.25H22.7209L22.7063 24.9958L24.1209 24.9813C24.1209 24.9813 25.448 24.7479 25.4626 23.45C25.5209 21.9917 24.2813 21.9917 24.0626 21.9917C23.873 21.9917 22.5022 22.0646 22.5022 23.2604H20.2855C20.2855 23.2604 20.3438 20.2563 24.0626 20.2563C27.8543 20.2563 27.6501 23.2021 27.6501 23.2021C27.6501 23.2021 27.7084 25.025 26.0313 25.7104L26.7897 26.25H29.1668ZM13.0084 23.3333H10.8209V14.875L8.19592 15.6917V13.8979L12.7751 12.2646H13.0084V23.3333Z"
      fill="#9AD200"
    />
  </svg>
)
export const IconMeterReading2 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83342 5.83334H29.1668C29.9403 5.83334 30.6822 6.14063 31.2291 6.68762C31.7761 7.2346 32.0834 7.97646 32.0834 8.75001V26.25C32.0834 27.0236 31.7761 27.7654 31.2291 28.3124C30.6822 28.8594 29.9403 29.1667 29.1668 29.1667H5.83342C5.05987 29.1667 4.318 28.8594 3.77102 28.3124C3.22404 27.7654 2.91675 27.0236 2.91675 26.25V8.75001C2.91675 7.97646 3.22404 7.2346 3.77102 6.68762C4.318 6.14063 5.05987 5.83334 5.83342 5.83334V5.83334ZM5.83342 8.75001V26.25H16.0417V8.75001H5.83342ZM29.1668 26.25V8.75001H27.3584C27.7084 9.53751 27.6355 10.3104 27.6355 10.3979C27.5334 11.375 26.848 12.3958 26.6001 12.7604L23.2022 16.4792L28.0438 16.45L28.0584 18.2292L20.4751 18.1854L20.4167 16.7271C20.4167 16.7271 24.8647 12.0167 25.0834 11.5938C25.2876 11.1854 26.1188 8.75001 24.0626 8.75001C22.2688 8.82293 22.473 10.6458 22.473 10.6458L20.2272 10.6604C20.2272 10.6604 20.2417 9.69793 20.7813 8.75001H18.9584V26.25H22.7209L22.7063 24.9958L24.1209 24.9813C24.1209 24.9813 25.448 24.7479 25.4626 23.45C25.5209 21.9917 24.2813 21.9917 24.0626 21.9917C23.873 21.9917 22.5022 22.0646 22.5022 23.2604H20.2855C20.2855 23.2604 20.3438 20.2563 24.0626 20.2563C27.8543 20.2563 27.6501 23.2021 27.6501 23.2021C27.6501 23.2021 27.7084 25.025 26.0313 25.7104L26.7897 26.25H29.1668ZM13.0084 23.3333H10.8209V14.875L8.19592 15.6917V13.8979L12.7751 12.2646H13.0084V23.3333Z"
      fill="grey"
    />
  </svg>
)

export const IconGas = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.4083 18.0104C26.1187 12.0604 17.9666 11.7396 19.9353 3.09165C20.0812 2.44998 19.3958 1.95415 18.8416 2.28956C13.5478 5.4104 9.74158 11.6666 12.9353 19.8625C13.1978 20.5333 12.4103 21.1604 11.8416 20.7229C9.202 18.725 8.92492 15.8521 9.15825 13.7958C9.24575 13.0375 8.25408 12.6729 7.83117 13.3C6.8395 14.8166 5.83325 17.2666 5.83325 20.9562C6.38742 29.1229 13.2853 31.6312 15.7645 31.9521C19.3083 32.4041 23.1437 31.7479 25.8999 29.225C28.9333 26.4104 30.0416 21.9187 28.4083 18.0104ZM14.8749 25.3458C16.9749 24.8354 18.0541 23.3187 18.3458 21.9771C18.827 19.8916 16.9458 17.85 18.2145 14.5541C18.6958 17.2812 22.9833 18.9875 22.9833 21.9625C23.0999 25.6521 19.1041 28.8166 14.8749 25.3458Z"
      fill="#9AD200"
    />
  </svg>
)

export const IconElectricity = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 2.94583C9.46455 2.94583 2.9458 9.46458 2.9458 17.5C2.9458 25.5354 9.46455 32.0542 17.5 32.0542C25.5354 32.0542 32.0541 25.5354 32.0541 17.5C32.0541 9.46458 25.5354 2.94583 17.5 2.94583ZM16.7416 29.1667V20.0375H11.6666L18.9583 5.83333V14.9625H23.8437L16.7416 29.1667Z"
      fill="#9AD200"
    />
  </svg>
)

export const IconPayment = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.625 17.5V8.74999C30.625 7.14582 29.3125 5.83332 27.7083 5.83332H26.25V2.91666H23.3333V5.83332H11.6667V2.91666H8.75V5.83332H7.29167C5.6875 5.83332 4.375 7.14582 4.375 8.74999V29.1667C4.375 30.7708 5.6875 32.0833 7.29167 32.0833H17.5V29.1667H7.29167V14.5833H27.7083V17.5H30.625ZM22.8083 29.1667C23.4354 31.2812 25.3896 32.8125 27.7083 32.8125C30.5229 32.8125 32.8125 30.5229 32.8125 27.7083C32.8125 24.8937 30.5229 22.6042 27.7083 22.6042C26.3229 22.6042 25.0542 23.1583 24.1354 24.0625H26.25V26.25H20.4167V20.4167H22.6042V22.5021C23.9167 21.2187 25.725 20.4167 27.7083 20.4167C31.7333 20.4167 35 23.6833 35 27.7083C35 31.7333 31.7333 35 27.7083 35C24.1792 35 21.2333 32.4917 20.5625 29.1667H22.8083Z"
      fill="#9AD200"
    />
  </svg>
)

export const IconPayment2 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.625 17.5V8.74999C30.625 7.14582 29.3125 5.83332 27.7083 5.83332H26.25V2.91666H23.3333V5.83332H11.6667V2.91666H8.75V5.83332H7.29167C5.6875 5.83332 4.375 7.14582 4.375 8.74999V29.1667C4.375 30.7708 5.6875 32.0833 7.29167 32.0833H17.5V29.1667H7.29167V14.5833H27.7083V17.5H30.625ZM22.8083 29.1667C23.4354 31.2812 25.3896 32.8125 27.7083 32.8125C30.5229 32.8125 32.8125 30.5229 32.8125 27.7083C32.8125 24.8937 30.5229 22.6042 27.7083 22.6042C26.3229 22.6042 25.0542 23.1583 24.1354 24.0625H26.25V26.25H20.4167V20.4167H22.6042V22.5021C23.9167 21.2187 25.725 20.4167 27.7083 20.4167C31.7333 20.4167 35 23.6833 35 27.7083C35 31.7333 31.7333 35 27.7083 35C24.1792 35 21.2333 32.4917 20.5625 29.1667H22.8083Z"
     fill="grey"
    />
  </svg>
)
export const IconArrowForward = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 3L7.9425 4.0575L12.1275 8.25H3V9.75H12.1275L7.9425 13.9425L9 15L15 9L9 3Z"
      fill="white"
    />
  </svg>
)
